<template>
  <v-footer app height=60>
    <v-spacer></v-spacer>
    {{ name }}
    <v-btn color="primary" @click="logout" v-if="isAuthenticated">Salir</v-btn>  
  </v-footer>
</template>

<style>
</style>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { AUTH_LOGOUT } from '@/store/actions/auth'

  export default {
    name: 'peu',
    data () {
      return {}
    },
    methods: {
      logout: function () {
        this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/'))
      }
    },
    computed: {
      ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded']),
      ...mapState({
        authLoading: state => state.auth.status === 'loading',
        name: state => state.user.profile.NOMBRE
      })
    },
  }
</script>